/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from "vue";
import Router from "vue-router";
import VueGtag from "vue-gtag";
import store from "./store/store";

Vue.use(Router);

let entryUrl = null;
const guard = async (to, from, next) => {
  //await store.dispatch('checkAuth');

  if (store.state.auth.isUserLoggedIn) {
    next();
  } else {
    entryUrl = to.path; // store entry url before redirect
    next("/login");
  }
};

const router = new Router(
  {
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
    routes: [
      {
        // =============================================================================
        // MAIN LAYOUT ROUTES
        // =============================================================================
        path: "",

        component: () => import("./layouts/main/Main.vue"),
        //beforeEnter: guard,
        meta: {
          requiresAuth: true,
        },
        name: "root",
        children: [
          {
            path: "admin",
            name: "admin",
            redirect: { name: "dashboard" },
            component: () => import("./views/Admin.vue"),
            children: [
              {
                path: "",
                name: "dashboard",
                component: () => import("./views/Home.vue"),
              },

              //Partners
              {
                path: "partners/list",
                name: "partners.list",
                component: () => import("./views/partners/list.vue"),
              },
              {
                path: "partners/add",
                name: "partners.add",
                component: () => import("./views/partners/edit.vue"),
              },
              {
                path: "partners/edit/:id",
                name: "partners.edit",
                component: () => import("./views/partners/edit.vue"),
              },
              {
                path: "partners/partnerAccount",
                name: "partners.account",
                component: () => import("./views/partners/partnerAccount.vue"),
              },

              //Zones
              {
                path: "zones/list",
                name: "zones.list",
                component: () => import("./views/zones/list.vue"),
              },
              //Routes
              {
                path: "routes/list",
                name: "routes List",
                component: () => import("./views/routes/list.vue"),
              },
              {
                path: "routes/add",
                name: "routes Add",
                component: () => import("./views/routes/add.vue"),
              },
              {
                path: "routes/edit/:id",
                name: "routes.edit",
                component: () => import("./views/routes/add.vue"),
              },
              {
                path: "routes/stations",
                name: "routes.stations",
                component: () => import("./views/routes/stations.vue"),
              },
              {
                path: "routes/groups",
                name: "routes.groups",
                component: () => import("./views/routes/groups.vue"),
              },
              {
                path: "routes/stations/:id",
                name: "routes.stations.edit",
                component: () => import("./views/routes/station.vue"),
              },

              //Vehicles
              {
                path: "vehicles/list",
                name: "vehicles List",
                component: () => import("./views/vehicles/list.vue"),
              },
              {
                path: "vehicles/add",
                name: "vehicles Add",
                component: () => import("./views/vehicles/edit.vue"),
              },
              {
                path: "vehicles/edit/:id",
                name: "vehicles.edit",
                component: () => import("./views/vehicles/edit.vue"),
              },

              // Drivers
              {
                path: "drivers/list",
                name: "drivers List",
                component: () => import("./views/drivers/list.vue"),
              },
              {
                path: "drivers/add",
                name: "drivers Add",
                component: () => import("./views/drivers/edit.vue"),
              },
              {
                path: "drivers/edit/:id",
                name: "drivers.edit",
                component: () => import("./views/drivers/edit.vue"),
              },
              {
                path: "drivers/driversLogs/:id",
                name: "drivers.Logs",
                component: () => import("./views/drivers/driversLogs.vue"),
              },
              {
                path: "drivers/driversLogsDetail/:id",
                name: "drivers.LogsDetails",
                component: () =>
                  import("./views/drivers/driversLogsDetail.vue"),
              },

              // TRIPS
              {
                path: "trips/list",
                name: "trips List",
                component: () => import("./views/trips/list.vue"),
              },
              {
                path: "trips/details/:trip_id",
                name: "trips details",
                component: () => import("./views/trips/details/details.vue"),
              },
              {
                path: "trips/add",
                name: "trips.add",
                component: () => import("./views/trips/edit.vue"),
              },
              {
                path: "trips/monitor",
                name: "trips.monitor",
                component: () => import("./views/trips/monitor.vue"),
              },

              // Coupons
              {
                path: "coupons/list",
                name: "coupons List",
                component: () => import("./views/coupons/list.vue"),
              },
              {
                path: "coupons/edit/:id",
                name: "coupons.edit",
                component: () => import("./views/coupons/edit.vue"),
              },
              {
                path: "coupons/add",
                name: "coupons Add",
                component: () => import("./views/coupons/edit.vue"),
              },
              // Tools
              {
                path: "tools/find",
                name: "tools Find",
                component: () => import("./views/tools/find.vue"),
              },

              //Users
              {
                path: "customers/list",
                name: "customers.list",
                component: () => import("./views/customers/list.vue"),
              },
              {
                path: "customers/list/:id",
                name: "customers.detail",
                component: () => import("./views/customers/detail.vue"),
              },

              {
                path: "customers/orders",
                name: "customers.orders",
                component: () => import("./views/customers/orders.vue"),
              },
              {
                path: "users/history/:id",
                name: "admin.users.history",
                component: () => import("./views/admin/users/history.vue"),
              },
            ],
          },

          {
            path: "partner",
            name: "partner",
            component: () => import("./views/Partner.vue"),
            redirect: { name: "partner.dashboard" },
            children: [
              {
                path: "",
                name: "partner.dashboard",
                component: () => import("./views/trips/list.vue"),
              },
              // TRIPS
              {
                path: "trips/list",
                name: "partner.trips",
                component: () => import("./views/trips/list.vue"),
              },
              {
                path: "trips/details/:trip_id",
                name: "partner.trips.details",
                component: () => import("./views/trips/details/details.vue"),
              },
              {
                path: "trips/add",
                name: "partner.trips.add",
                component: () => import("./views/trips/edit.vue"),
              },

              {
                path: "trips/monitor",
                name: "partner.trips.monitor",
                component: () => import("./views/trips/monitor.vue"),
              },
              //Vehicles
              {
                path: "vehicles/list",
                name: "partner.vehicles.list",
                component: () => import("./views/vehicles/list.vue"),
              },
              {
                path: "vehicles/add",
                name: "partner.vehicles Add",
                component: () => import("./views/vehicles/edit.vue"),
              },
              {
                path: "vehicles/edit/:id",
                name: "partner.vehicles.edit",
                component: () => import("./views/vehicles/edit.vue"),
              },

              // Drivers
              {
                path: "drivers/list",
                name: "partner.drivers.list",
                component: () => import("./views/drivers/list.vue"),
              },
              {
                path: "drivers/add",
                name: "partner.drivers.add",
                component: () => import("./views/drivers/edit.vue"),
              },
              {
                path: "drivers/edit/:id",
                name: "partner.drivers.edit",
                component: () => import("./views/drivers/edit.vue"),
              },
              {
                path: "drivers/driversLogs/:id",
                name: "partner.drivers.Logs",
                component: () => import("./views/drivers/driversLogs.vue"),
              },
              {
                path: "drivers/driversLogsDetail/:id",
                name: "partner.drivers.LogsDetails",
                component: () =>
                  import("./views/drivers/driversLogsDetail.vue"),
              },

              {
                path: "users",
                name: "partner.users",
                //component: () => import('./views/partners/users/index.vue'),
                component: () => import("./views/partners/users/users.vue"),
                children: [
                  //Partner Users
                  {
                    path: "zones/:zone_id/",
                    name: "partner.zones.users.list",
                    component: () => import("./views/partners/users/users.vue"),
                  },
                ],
              },

              {
                path: "users/history/:id",
                name: "partner.users.history",
                component: () => import("./views/partners/users/history.vue"),
              },
              {
                path: "users/delete/:id",
                name: "partner.users.delete",
                component: () => import("./views/partners/users/delete.vue"),
              },
              {
                path: "reports/routes",
                name: "partner.reports.routes",
                component: () => import("./views/partners/reports/Routes.vue"),
              },
              {
                path: "reports/trips",
                name: "partner.reports.trips",
                component: () => import("./views/partners/reports/Trips.vue"),
              },
              {
                path: "reports/passengers",
                name: "partner.reports.passengers",
                component: () =>
                  import("./views/partners/reports/Passenger.vue"),
              },
              {
                path: "reports/codes",
                name: "partner.reports.codes",
                component: () => import("./views/partners/reports/Codes.vue"),
              },
              {
                path: "reports/drivers",
                name: "partner.reports.drivers",
                component: () => import("./views/partners/reports/Drivers.vue"),
              },
              {
                path: "reports/drivers/:driver_id/trips",
                name: "partner.reports.drivers.detail.trips",
                component: () => import("./views/partners/reports/Driver.vue"),
              },
            ],
          },
        ],
      },
      // =============================================================================
      // FULL PAGE LAYOUTS
      // =============================================================================
      {
        path: "",
        component: () => import("@/layouts/full-page/FullPage.vue"),
        children: [
          // =============================================================================
          // PAGES
          // =============================================================================
          {
            path: "/login",
            name: "login",
            component: () => import("./views/pages/Login"),
          },
          {
            path: "/pages/login",
            name: "page-login",
            component: () => import("@/views/pages/Login.vue"),
          },
          {
            path: "/pages/error-404",
            name: "page-error-404",
            component: () => import("@/views/pages/Error404.vue"),
          },
        ],
      },
      // Redirect to 404 page, if no match found
      {
        path: "*",
        redirect: "/pages/error-404",
      },
    ],
  },
  router
);

Vue.use(VueGtag, {
  config: { id: "GTM-T9DG3JV" },
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
